import React from 'react';

type Props = {
  children?: React.ReactNode;
};

export default function H1({ children, ...rest }: Props) {
  return React.createElement(
    'h1',
    {
      ...rest,
      className: 'text-2xl lg:text-5xl font-bold leading-snug text-letters-black dark:text-white'
    },
    children
  );
}
